import {
  Box,
  BoxProps,
  Image,
  ImageProps,
  Text,
  Tooltip,
} from "@chakra-ui/react";

const AdsetImage = ({
  adset,
  imageProps = {},
  containerProps = {},
}: {
  imageProps?: ImageProps;
  containerProps?: BoxProps;
  adset?: {
    id?: string;
    ads?: {
      name?: string;
      creative?: {
        message?: string;
        images?: {
          hash?: string;
          picture_url?: string;
          name?: string;
          description?: string;
        }[];
        videos?: {
          source?: string;
          thumbnail_url?: string;
        }[];
        variations?: {
          images?: {
            picture_url?: string;
          }[];
          videos?: {
            source?: string;
            thumbnail_url?: string;
          }[];
        };
      };
    }[];
  };
}) => {
  const image =
    adset?.ads?.[0]?.creative?.variations?.images?.at(0)?.picture_url ||
    adset?.ads?.[0]?.creative?.images?.at(0)?.picture_url ||
    adset?.ads?.[0]?.creative?.videos?.at(0)?.thumbnail_url ||
    adset?.ads?.[0]?.creative?.variations?.videos?.at(0)?.thumbnail_url;

  const hasMoreAds = adset?.ads?.length > 1;
  return (
    <Box position={"relative"} {...containerProps}>
      {hasMoreAds ? (
        <>
          <Box
            pos="absolute"
            zIndex={1}
            rounded="md"
            top={1}
            left={1}
            background="gray.400"
            width={8}
            height={8}
            {...imageProps}
          />
          <Box
            rounded="full"
            zIndex={15}
            position={"absolute"}
            background="white"
            width={3}
            h={3}
            bottom={-1}
            right={-1}
            display="flex"
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Text
              fontWeight={"bold"}
              fontSize={"xs"}
              textAlign={"center"}
              height={"full"}
              lineHeight={"100%"}
            >
              {adset.ads.length}
            </Text>
          </Box>
        </>
      ) : null}
      <Tooltip
        label={adset?.ads
          ?.map((ad) => `${ad.name}`)
          .map((t, i) => (
            <Text>{`${i + 1}. ${t}`}</Text>
          ))}
      >
        <Image
          rounded="md"
          src={image}
          objectFit={"cover"}
          background="gray.300"
          width={8}
          position={"relative"}
          height={8}
          zIndex={10}
          {...imageProps}
        />
      </Tooltip>
    </Box>
  );
};

export default AdsetImage;
